"use client";

import { homeTheme } from "@/lib/theme/home-theme";
import { useLanguage } from "@/lib/i18n/context";
import { useResolvedTheme } from "@/lib/hooks/use-resolved-theme";

export function ContactSection() {
  const { t } = useLanguage();
  const { isLight } = useResolvedTheme();

  return (
    <section id="kontakt" className="relative z-30 w-full py-4 sm:py-6">
      {/* 
        Responsive Floating Tile
        Optimized for mobile with adjusted padding and stacking.
      */}
      <div className={`relative mx-auto max-w-[95%] overflow-hidden rounded-[2rem] shadow-xl ${homeTheme.contactSection}`}>
        {/* Background Decorative Layers */}
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-radial-[circle_at_center] from-transparent via-black/5 to-black/25"
        />

        {/* Decorative blurred orbs - repositioned for better mobile flow */}
        <div aria-hidden="true" className="absolute -top-12 -left-12 h-48 w-48 rounded-full bg-white/20 blur-2xl opacity-50" />
        <div aria-hidden="true" className="absolute -bottom-12 -right-12 h-48 w-48 rounded-full bg-white/10 blur-2xl opacity-30" />

        {/* Grid pattern overlay */}
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)",
            backgroundSize: "40px 40px",
          }}
        />

        {/* Noise texture overlay */}
        <div
          aria-hidden="true"
          className={`absolute inset-0 pointer-events-none ${isLight ? 'opacity-20' : 'opacity-40'} mix-blend-overlay`}
          style={{
            filter: "contrast(150%) brightness(100%)"
          }}
        />

        <div className="relative z-10 mx-auto max-w-7xl px-6 py-4 md:py-2 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-4">
          <div className="text-center md:text-left">
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl text-white">
              {t.home.contactTitle}
            </h2>
            <p className={`${homeTheme.contactDesc} mt-1 text-sm sm:text-base opacity-90 max-w-xl mx-auto md:mx-0`}>
              {t.home.contactDesc}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 shrink-0 w-full sm:w-auto">
            <a
              href="mailto:kontakt@automatyka-cnc.pl"
              className="w-full sm:w-auto rounded-full bg-white px-8 py-3 text-sm font-bold shadow-lg transition-all hover:scale-105 active:scale-95 text-orange-600 hover:bg-orange-50 dark:text-blue-600 dark:hover:bg-blue-50 text-center"
            >
              {t.home.contactBtnMail}
            </a>
            <a
              href="tel:+48500076868"
              className="w-full sm:w-auto px-8 py-3 text-sm font-bold text-white border border-white/20 rounded-full hover:bg-white/10 transition-all flex items-center justify-center gap-1.5 whitespace-nowrap"
            >
              {t.home.contactBtnPhone} <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
